import NavTreeWithProvider from "./NavTreeWithProvider";

export default NavTreeWithProvider;
